var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"w-full max-display flex justify-center"},[_c('header-logo-svg',{staticClass:"cursor-pointer",attrs:{"logoColour":_vm.colourLogo},on:{"showStartScreen":function($event){return _vm.$emit('showStartScreen')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }